import {
  Container,
} from './styles';

export const TermsAndConditions = () => {
  return (
    <Container>
      <div>
        <h3><span>Terms and Conditions</span></h3>
        <p>
          <strong>
            PLEASE NOTE THAT YOUR USE OF AND ACCESS TO OUR SERVICES (DEFINED BELOW) ARE SUBJECT TO THE
            FOLLOWING TERMS; IF YOU DO NOT AGREE TO ALL OF THE FOLLOWING, YOU MAY NOT USE OR ACCESS THE SERVICES IN
            ANY MANNER.
          </strong>
        </p>
        <h3>
          <strong>Terms of Use</strong>
        </h3>
        <p>Effective date: March 2019</p>
        <p>
          Welcome to Color My Life. Please read on to learn the rules and restrictions that govern your use of our
          website, products, services and applications (the “Services”). If you have any questions, comments, or
          concerns regarding these terms or the Services, please contact us at&nbsp;
          <a
            href="mailto:support@colormylife.com"
          >
            support@colormylife.com
          </a>
          , 3916 N. Potsdam Ave. Ste 4066,
          Sioux Falls, SD, 57104, USA.
        </p>
        <p>
          These Terms of Use (the “Terms”) are a binding contract between you and Color My Life Inc. (“CML,” “we”
          and “us”).&nbsp; You must agree to and accept all of the Terms, or you don’t have the right to use the
          Services. Your using the Services in any way means that you agree to all of these Terms, and these Terms
          will remain in effect while you use the Services. These Terms include the provisions in this document,
          as well as those in the&nbsp;
          <a href="http://colormylife.com/privacy/">Privacy Policy</a>
          .
        </p>
        <p>
          <strong>NOTICE: Please read these Terms carefully.</strong>
          &nbsp;They cover important information about
          Services provided to you and any charges, taxes, and fees we bill you.&nbsp;
          <strong>
            These Terms include
            information about future changes to these Terms, limitations of liability, a class action waiver,
            and resolution of disputes by arbitration&nbsp;instead of in
            court.&nbsp;
          </strong>
          <strong>&nbsp;</strong>
        </p>
        <h3>
          <strong>Will these Terms ever change?</strong>
        </h3>
        <p>
          We are constantly trying to improve our Services, so these Terms may need to change along with the
          Services. We reserve the right to change the Terms at any time, but if we do, we will bring it to your
          attention by placing a notice on the
          <a
            href="http://colormylife.com"
          >
            http://colormylife.com
          </a>
          {' '}
          website, by sending you an email, and/or by
          some other means.
        </p>
        <p>
          If you don’t agree with the new Terms, you are free to reject them; unfortunately, that means you will no
          longer be able to use the Services. If you use the Services in any way after a change to the Terms is
          effective, that means you agree to all of the changes.
        </p>
        <p>
          Except for changes by us as described here, no other amendment or modification of these Terms will be
          effective unless in writing and signed by both you and us.
        </p>
        <h3>
          <strong>What about my privacy?</strong>
        </h3>
        <p>
          CML takes the privacy of its users very seriously. For the current CML Privacy Policy, please click&nbsp;
          <a href="http://colormylife.com/privacy">here</a>
          .
        </p>
        <p>
          The Children’s Online Privacy Protection Act (“COPPA”) requires that online service providers obtain
          parental consent before they knowingly collect personally identifiable information online from children
          who are under 13. We do not knowingly collect or solicit personally identifiable information from
          children under 13; if you are a child under 13, please do not attempt to register for the Services or
          send any personal information about yourself to us. If we learn we have collected personal information
          from a child under 13, we will delete that information as quickly as possible. If you believe that a
          child under 13 may have provided us with personal information, please contact us at&nbsp;
          <a
            href="mailto:support@colormylife.com"
          >
            support@colormylife.com
          </a>
          .
        </p>
        <p>
          By providing us with your wireless phone number, you confirm that you want CML to send you information we
          think may be of interest to you, which may include CML using automated dialing technology to text you at
          the wireless number you provided. Additionally, we may collect and analyze data from certain of our
          products (for example, the items you add to your catalog) in order to enable our provision of the
          Services.
        </p>
        <h3>
          <strong>What are the basics of using CML Services?</strong>
        </h3>
        <p>
          You may be required to sign up for an account, and provide an email address and select a password. You
          promise to provide us with accurate, complete, and updated registration information about yourself. You
          may not transfer your account to anyone else without our prior written permission.
        </p>
        <p>
          You represent and warrant that you are an individual of legal age to form a binding contract (or if not,
          you’ve received your parent’s or guardian’s permission to use the Services and gotten your parent or
          guardian to agree to these Terms on your behalf).
        </p>
        <p>
          You will only use the Services for your own internal, personal, non-commercial use, and not on behalf of
          or for the benefit of any third party, and only in a manner that complies with all laws that apply to
          you. If your use of the Services is prohibited by applicable laws, then you aren’t authorized to use the
          Services. We can’t and won’t be responsible for your using the Services in a way that breaks the
          law.
        </p>
        <p>
          You will not share your account or password with anyone, and you must protect the security of your
          account and your password. You’re responsible for any activity associated with your account.
        </p>
        <h3>
          <strong>Consent to receive periodic messages</strong>
        </h3>
        <p>
          As part of the Services, you may receive communications through the Services, including messages that CML
          sends you (for example, via email). When signing up for the Services, you will receive a welcome message
          and instructions on how to stop receiving messages. BY SIGNING UP FOR THE SERVICES, YOU AGREE TO RECEIVE
          COMMUNICATIONS FROM CML, AND YOU REPRESENT AND WARRANT THAT EACH PERSON YOU REGISTER FOR THE SERVICES OR
          FOR WHOM YOU PROVIDE AN EMAIL ADDRESS HAS CONSENTED TO RECEIVE COMMUNICATIONS FROM CML. You agree to
          indemnify and hold CML harmless from and against any and all claims, liabilities, damages (actual and
          consequential), losses and expenses (including attorneys’ fees) arising from or in any way related to
          your breach of the foregoing.
        </p>
        <h3><strong>Your use of the Services is subject to the following additional restrictions:</strong></h3>
        <p>
          You represent, warrant, and agree that you will not use the Services or interact with the Services in a
          manner that:
        </p>
        <p>
          Infringes or violates the intellectual property rights or any other rights of anyone else (including
          CML); Violates any law or regulation, including, without limitation, any applicable export control laws;
          Is harmful, fraudulent, deceptive, threatening, harassing, defamatory, obscene, or otherwise
          objectionable; Jeopardizes the security of your CML account or anyone else’s (such as allowing someone
          else to log in to the Services as you); Attempts, in any manner, to obtain the password, account, or
          other security information from any other user; Violates the security of any computer network, or cracks
          any passwords or security encryption codes; Runs Maillist, Listserv, any form of auto-responder or
          “spam” on the Services, or any processes that run or are activated while you are not logged into the
          Services, or that otherwise interfere with the proper working of the Services (including by placing an
          unreasonable load on the Services’ infrastructure); “Crawls,” “scrapes,” or “spiders” any page, data, or
          portion of or relating to the Services or Content (through use of manual or automated means); Copies or
          stores any significant portion of the Content; Decompiles, reverse engineers, or otherwise attempts to
          obtain the source code or underlying ideas or information of or relating to the Services.
        </p>
        <p>
          A violation of any of the foregoing is grounds for termination of your right to use or access the
          Services.
        </p>
        <h3><strong>What are my rights in the Services?</strong></h3>
        <p>
          The materials displayed or performed or available on or through the Services, including, but not limited
          to, text, graphics, data, articles, photos, images, illustrations, and so forth (all of the foregoing,
          the “Content”) are protected by copyright and/or other intellectual property laws. You promise to abide
          by all copyright notices, trademark rules, information, and restrictions contained in any Content you
          access through the Services, and you won’t use, copy, reproduce, modify, translate, publish, broadcast,
          transmit, distribute, perform, upload, display, license, sell, commercialize or otherwise exploit for
          any purpose any Content not owned by you, (i) without the prior consent of the owner of that Content or
          (ii) in a way that violates someone else’s (including CML’s) rights.
        </p>
        <p>
          You understand that CML owns the Services. You won’t modify, publish, transmit, participate in the
          transfer or sale of, reproduce (except as expressly provided in this Section), create derivative works
          based on, or otherwise exploit any of the Services.
        </p>
        <p>
          The Services may allow you to copy or download certain Content; please remember that just because this
          functionality exists, doesn’t mean that all the restrictions above don’t apply – they do!
        </p>
        <h3>
          <strong>
            Who is responsible for links or connections to third party websites or services through the
            Services?
          </strong>
        </h3>
        <p>
          The Services may contain links or connections to third party websites or services that are not owned or
          controlled by CML. When you access third party websites or use third party services, you accept that
          there are risks in doing so, and that CML&nbsp;is not responsible for such risks. We encourage you to be
          aware when you leave the Services and to read the terms and conditions and privacy policy of each third
          party website or service that you visit or utilize.
        </p>
        <p>
          CML has no control over, and assumes no responsibility for, the content, accuracy, privacy policies, or
          practices of or opinions expressed in any third party websites or by any third party that you interact
          with through the Services. In addition, CML will not and cannot monitor, verify, censor or edit the
          content of any third party site or service. By using the Services, you release and hold us harmless from
          any and all liability arising from your use of any third party website or service.
        </p>
        <p>
          Your interactions with organizations and/or individuals found on or through the Services, including
          payment and delivery of goods or services, and any other terms, conditions, warranties or
          representations associated with such dealings, are solely between you and such organizations and/or
          individuals. You should make whatever investigation you feel necessary or appropriate before proceeding
          with any online or offline transaction with any of these third parties. You agree that CML shall not be
          responsible or liable for any loss or damage of any sort incurred as the result of any such
          dealings.
        </p>
        <p>
          If there is a dispute between users and any third party, you agree that CML is under no obligation to
          become involved. In the event that you have a dispute with any third party, you release CML, its
          directors, officers, employees, agents and successors from claims, demands and damages of every kind or
          nature, known or unknown, suspected or unsuspected, disclosed or undisclosed, arising out of or in any
          way related to such disputes and/or our Services.&nbsp; If you are a California resident, you shall and
          hereby do waive California Civil Code Section 1542, which says: &quot;A general release does not extend to
          claims which the creditor does not know or suspect to exist in his favor at the time of executing the
          release, which, if known by him must have materially affected his settlement with the debtor.&quot;
        </p>
        <h3><strong>Will CML ever change the Services?</strong></h3>
        <p>
          We’re always trying to improve the Services, so they may change over time. We may suspend or discontinue
          any part of the Services, or we may introduce new features or impose limits on certain features or
          restrict access to parts or all of the Services. We’ll try to give you notice when we make a material
          change to the Services that would adversely affect you, but this isn’t always practical. Similarly, we
          reserve the right to remove any Content from the Services at any time, for any reason (including, but
          not limited to, if someone alleges you contributed that Content in violation of these Terms), in our
          sole discretion, and without notice.
        </p>
        <h3><strong>Do the Services cost anything?</strong></h3>
        <p>
          The Services may be free or we may charge a fee for using the Services.&nbsp; If you are using a free
          version of the Services, we will notify you before any Services you are then using begin carrying a fee,
          and if you wish to continue using such Services, you must pay all applicable fees for such Services.
          Note that if you elect to receive email messages through the Services, data rates may apply. Any and all
          such charges, fees or costs are your sole responsibility. You should consult with your carrier to
          determine what rates, charges, fees or costs may apply to your use of the Services.
        </p>
        <p>
          <strong>Paid Services</strong>
          . Certain of our Services may be subject to payments now or in the future
          (the “Paid Services”). Please note that any payment terms presented to you in the process of using or
          signing up for a Paid Service are deemed part of these Terms.&nbsp;
          <strong>Billing</strong>
          . We use a
          third-party payment processor (the “Payment Processor”) to bill you through a payment account linked to
          your account on the Services (your “Billing Account”) for use of the Paid Services. The processing of
          payments will be subject to the terms, conditions and privacy policies of the Payment Processor in
          addition to these Terms. We are not responsible for error by the Payment Processor. By choosing to use
          Paid Services, you agree to pay us, through the Payment Processor, all charges at the prices then in
          effect for any use of such Paid Services in accordance with the applicable payment terms and you
          authorize us, through the Payment Processor, to charge your chosen payment provider (your “Payment
          Method”). You agree to make payment using that selected Payment Method. We reserve the right to correct
          any errors or mistakes that the Payment Processor makes even if it has already requested or received
          payment.&nbsp;
          <strong>Payment Method</strong>
          . The terms of your payment will be based on your Payment
          Method and may be determined by agreements between you and the financial institution, credit card issuer
          or other provider of your chosen Payment Method. If we, through the Payment Processor, do not receive
          payment from you, you agree to pay all amounts due on your Billing Account upon demand.&nbsp;
          <strong>
            Current
            Information Required
          </strong>
          . YOU MUST PROVIDE CURRENT, COMPLETE AND ACCURATE INFORMATION FOR YOUR
          BILLING ACCOUNT. YOU MUST PROMPTLY UPDATE ALL INFORMATION TO KEEP YOUR BILLING ACCOUNT CURRENT, COMPLETE
          AND ACCURATE (SUCH AS A CHANGE IN BILLING ADDRESS, CREDIT CARD NUMBER, OR CREDIT CARD EXPIRATION DATE),
          AND YOU MUST PROMPTLY NOTIFY US OR OUR PAYMENT PROCESSOR IF YOUR PAYMENT METHOD IS CANCELED (E.G., FOR
          LOSS OR THEFT) OR IF YOU BECOME AWARE OF A POTENTIAL BREACH OF SECURITY, SUCH AS THE UNAUTHORIZED
          DISCLOSURE OR USE OF YOUR USER NAME OR PASSWORD. CHANGES TO SUCH INFORMATION CAN BE MADE IN ACCOUNT
          SETTINGS.&nbsp; IF YOU FAIL TO PROVIDE ANY OF THE FOREGOING INFORMATION, YOU AGREE THAT WE MAY CONTINUE
          CHARGING YOU FOR ANY USE OF PAID SERVICES UNDER YOUR BILLING ACCOUNT UNLESS YOU HAVE TERMINATED YOUR
          PAID SERVICES AS SET FORTH ABOVE.&nbsp;
          <strong>Change in Amount Authorized</strong>
          . If the amount to be
          charged to your Billing Account varies from the amount you preauthorized (other than due to the
          imposition or change in the amount of state sales taxes), you have the right to receive, and we shall
          provide, notice of the amount to be charged and the date of the charge before the scheduled date of the
          transaction. Any agreement you have with your payment provider will govern your use of your Payment
          Method. You agree that we may accumulate charges incurred and submit them as one or more aggregate
          charges during or at the end of each billing cycle.&nbsp;
          <strong>Reaffirmation of Authorization</strong>
          .
          Your non-termination or continued use of a Paid Service reaffirms that we are authorized to charge your
          Payment Method for that Paid Service. We may submit those charges for payment and you will be
          responsible for such charges. This does not waive our right to seek payment directly from you. Your
          charges may be payable in advance, in arrears, per usage, or as otherwise described when you initially
          selected to use the Paid Service.
        </p>
        <p>
          <strong>Free Trials and Other Promotions</strong>
          . Any free trial or other promotion that provides access
          to a Paid Service must be used within the specified time of the trial. You must stop using a Paid
          Service before the end of the trial period in order to avoid being charged for that Paid Service. If you
          cancel prior to the end of the trial period and are inadvertently charged for a Paid Service, please
          contact us at&nbsp;
          <a href="mailto:support@colormylife.com">support@colormylife.com</a>
          .
        </p>
        <h3><strong>What if I want to stop using the Services?&nbsp;</strong></h3>
        <p>
          You’re free to do that at any time, by cancelling in the app. Payments, be they monthly or annually, will
          not be charged starting on the day following cancellation. Where pre-payment has been made for services,
          they will be available up until the time that the prepaid period ends.
        </p>
        <p>
          CML is also free to terminate (or suspend access to) your use of the Services or your account, for any
          reason in our discretion, including your breach of these Terms. CML has the sole right to decide whether
          you are in violation of any of the restrictions set forth in these Terms.
        </p>
        <p>
          Account termination may result in destruction of any Content associated with your account, so keep that
          in mind before you decide to terminate your account. We will try to provide advance notice to you prior
          to our terminating your account&nbsp; (to the extent allowed by law and these Terms), but we may not do
          so if we determine it would be impractical, illegal, not in the interest of someone’s safety or
          security, or otherwise harmful to the rights or property of Company.
        </p>
        <p>
          Provisions that, by their nature, should survive termination of these Terms shall survive termination. By
          way of example, all of the following will survive termination: any obligation you have to pay us or
          indemnify us, any limitations on our liability, any terms regarding ownership or intellectual property
          rights, and terms regarding disputes between us, including without limitation the arbitration
          agreement.
        </p>
        <h3>
          <strong>I use the CML App available via the Apple App Store – should I know anything about that?</strong>
        </h3>
        <p>
          These Terms apply to your use of all the Services, including the iOS applications available via the
          Apple, Inc. (“Apple”) App Store (the “Application”), but the following additional terms also apply to
          the Application:
        </p>
        <p>
          Both you and CML acknowledge that the Terms are concluded between you and CML only, and not with Apple,
          and that Apple is not responsible for the Application or the Content; The Application is licensed to you
          on a limited, non-exclusive, non-transferrable, non-sublicensable basis, solely to be used in connection
          with the Services for your private, personal, non-commercial use, subject to all the terms and
          conditions of these Terms as they are applicable to the Services; You will only use the Application in
          connection with an Apple device that you own or control; You acknowledge and agree that Apple has no
          obligation whatsoever to furnish any maintenance and support services with respect to the Application;
          In the event of any failure of the Application to conform to any applicable warranty, including those
          implied by law, you may notify Apple of such failure; upon notification, Apple’s sole warranty
          obligation to you will be to refund to you the purchase price, if any, of the Application; You
          acknowledge and agree that CML, and not Apple, is responsible for addressing any claims you or any third
          party may have in relation to the Application; You acknowledge and agree that, in the event of any third
          party claim that the Application or your possession and use of the Application infringes that third
          party’s intellectual property rights, CML, and not Apple, will be responsible for the investigation,
          defense, settlement and discharge of any such infringement claim; You represent and warrant that you are
          not located in a country subject to a U.S. Government embargo, or that has been designated by the U.S.
          Government as a “terrorist supporting” country, and that you are not listed on any U.S. Government list
          of prohibited or restricted parties; Both you and CML acknowledge and agree that, in your use of the
          Application, you will comply with any applicable third party terms of agreement which may affect or be
          affected by such use; and Both you and CML acknowledge and agree that Apple and Apple’s subsidiaries are
          third party beneficiaries of these Terms, and that upon your acceptance of these Terms, Apple will have
          the right (and will be deemed to have accepted the right) to enforce these Terms against you as the
          third party beneficiary hereof.
        </p>
        <h3><strong>What else do I need to know?</strong></h3>
        <p>
          <em>Warranty Disclaimer.</em>
          &nbsp;Neither CML nor its licensors or suppliers make any representations or
          warranties concerning any content contained in or accessed through the Services, and we will not be
          responsible or liable for the accuracy, copyright compliance, legality, or decency of material contained
          in or accessed through the Services. We (and our licensors and suppliers) make no representations or
          warranties regarding suggestions or recommendations of services or products offered or purchased through
          the Services. Products and services purchased or offered (whether or not following such recommendations
          and suggestions) through the Services are provided “AS IS” and without any warranty of any kind from CML
          or others (unless, with respect to such others only, provided expressly and unambiguously in writing by
          a designated third party for a specific product). THE SERVICES AND CONTENT ARE PROVIDED BY COMPANY (AND
          ITS LICENSORS AND SUPPLIERS) ON AN “AS-IS” BASIS, WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR
          IMPLIED, INCLUDING, WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, NON-INFRINGEMENT, OR THAT USE OF THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE. SOME STATES
          DO NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS, SO THE ABOVE LIMITATIONS MAY NOT APPLY
          TO YOU.
        </p>
        <p>
          <em>Limitation of Liability</em>
          . TO THE FULLEST EXTENT ALLOWED BY APPLICABLE LAW, UNDER NO CIRCUMSTANCES
          AND UNDER NO LEGAL THEORY (INCLUDING, WITHOUT LIMITATION, TORT, CONTRACT, STRICT LIABILITY, OR
          OTHERWISE) SHALL COMPANY (OR ITS LICENSORS OR SUPPLIERS) BE LIABLE TO YOU OR TO ANY OTHER PERSON FOR (A)
          ANY INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING DAMAGES FOR LOST
          PROFITS, LOSS OF GOODWILL, WORK STOPPAGE, ACCURACY OF RESULTS, OR COMPUTER FAILURE OR MALFUNCTION, OR
          (B) ANY AMOUNT, IN THE AGGREGATE, IN EXCESS OF THE GREATER OF (I) $100 OR (II) THE AMOUNTS PAID BY YOU
          TO COMPANY IN CONNECTION WITH THE SERVICES IN THE TWELVE (12) MONTH PERIOD PRECEDING THIS APPLICABLE
          CLAIM, OR (C) ANY MATTER BEYOND OUR REASONABLE CONTROL. SOME STATES DO NOT ALLOW THE EXCLUSION OR
          LIMITATION OF CERTAIN DAMAGES, SO THE ABOVE LIMITATION AND EXCLUSIONS MAY NOT APPLY TO YOU.
        </p>
        <p>
          <em>Indemnity</em>
          . To the fullest extent allowed by applicable law, you agree to indemnify and hold CML,
          its affiliates, officers, agents, employees, and partners harmless from and against any and all claims,
          liabilities, damages (actual and consequential), losses and expenses (including attorneys’ fees) arising
          from or in any way related to any third party claims relating to (a) your use of the Services (including
          any actions taken by a third party using your account), and (b) your violation of these Terms. In the
          event of such a claim, suit, or action (“Claim”), we will attempt to provide notice of the Claim to the
          contact information we have for your account (provided that failure to deliver such notice shall not
          eliminate or reduce your indemnification obligations hereunder).
        </p>
        <p>
          <em>Assignment</em>
          . You may not assign, delegate or transfer these Terms or your rights or obligations
          hereunder, or your Services account, in any way (by operation of law or otherwise) without CML’s prior
          written consent. We may transfer, assign, or delegate these Terms and our rights and obligations without
          consent.
        </p>
        <p>
          <em>Choice of Law</em>
          . These Terms are governed by and will be construed under the Federal Arbitration
          Act, applicable federal law, and the laws of the State of South Dakota, without regard to the conflicts
          of laws provisions thereof.
        </p>
        <p>
          <em>Arbitration Agreement.</em>
          &nbsp;Please read the following ARBITRATION AGREEMENT carefully because it
          requires you to arbitrate certain disputes and claims with CML and limits the manner in which you can
          seek relief from us. Both you and CML acknowledge and agree that for the purposes of any dispute arising
          out of or relating to the subject matter of these Terms, CML’s officers, directors, employees and
          independent contractors (“Personnel”) are third party beneficiaries of these Terms, and that upon your
          acceptance of these Terms, Personnel will have the right (and will be deemed to have accepted the right)
          to enforce these Terms against you as the third party beneficiary hereof.
        </p>
        <p>
          (a)&nbsp;
          <em>Arbitration Rules; Applicability of Arbitration Agreement</em>
          . Any dispute arising out of
          or relating to the subject matter of these Terms shall be finally settled by binding arbitration in
          Sioux Falls, South Dakota. The arbitration will proceed in the English language, in accordance with the
          Streamlined Arbitration Rules and Procedures of Judicial Arbitration and Mediation Services, Inc.
          (&quot;JAMS&quot;) then in effect, by one commercial arbitrator with substantial experience in resolving
          intellectual property and commercial contract disputes, who shall be selected from the appropriate list
          of JAMS arbitrators in accordance with such Rules. Judgment upon the award rendered by such arbitrator
          may be entered in any court of competent jurisdiction. Notwithstanding the foregoing obligation to
          arbitrate disputes, each party shall have the right to pursue injunctive or other equitable relief at
          any time, from any court of competent jurisdiction.
        </p>
        <p>
          (b)&nbsp;
          <em>Costs of Arbitration</em>
          . The JAMS rules will govern payment of all arbitration fees. CML
          will pay all arbitration fees for claims less than $75,000. CML will not seek its attorneys’ fees and
          costs in arbitration unless the arbitrator determines that your claim is frivolous.
        </p>
        <p>
          (c)&nbsp;
          <em>Small Claims Court</em>
          . Furthermore, either you or CML may assert claims, if they qualify,
          in small claims court in Sioux Falls, South Dakota or any United States county where you live or work.
        </p>
        <p>
          (d)&nbsp;
          <em>Waiver of Jury Trial</em>
          <strong>.&nbsp;</strong>
          YOU AND COMPANY WAIVE ANY CONSTITUTIONAL
          AND STATUTORY RIGHTS TO GO TO COURT AND HAVE A TRIAL IN FRONT OF A JUDGE OR JURY. You and CML are
          instead choosing to have claims and disputes resolved by arbitration. Arbitration procedures are
          typically more limited, more efficient, and less costly than rules applicable in court and are subject
          to very limited review by a court. In any litigation between you and CML over whether to vacate or
          enforce an arbitration award, YOU AND COMPANY WAIVE ALL RIGHTS TO A JURY TRIAL, and elect instead to
          have the dispute be resolved by a judge.
        </p>
        <p>
          (e) Waiver of Class or Consolidated Actions. ALL CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION
          AGREEMENT MUST BE ARBITRATED OR LITIGATED ON AN INDIVIDUAL BASIS AND NOT ON A CLASS BASIS. CLAIMS OF
          MORE THAN ONE CUSTOMER OR USER CANNOT BE ARBITRATED OR LITIGATED JOINTLY OR CONSOLIDATED WITH THOSE OF
          ANY OTHER CUSTOMER OR USER. If however, this waiver of class or consolidated actions is deemed invalid
          or unenforceable, neither you nor we are entitled to arbitration; instead all claims and disputes will
          be resolved in a court as set forth in (g) below.
          <strong>&nbsp;</strong>
        </p>
        <p>
          (f)&nbsp;
          <em>Opt-out</em>
          . You have the right to opt out of the provisions of this Section by sending
          written notice of your decision to opt out to the following address: Color My Life, Inc., 3916 N.
          Potsdam Ave. Ste. 4066, Sioux Falls, SD, 57104, USA&nbsp;postmarked within 30 days of first accepting
          these Terms. You must include (1) your name and residence address; (2) the email address associated with
          your account; and (3) a clear statement that you want to opt out of these Terms’ arbitration agreement.
        </p>
        <p>
          (g)&nbsp;
          <em>Exclusive Venue</em>
          . If you send the opt-out notice in (f), and/or in any circumstances
          where the foregoing arbitration agreement permits either you or CML to litigate any dispute arising out
          of or relating to the subject matter of these Terms in court, then the foregoing arbitration agreement
          will not apply to either party and both you and CML agree that any judicial proceeding (other than small
          claims actions) will be brought in the state or federal courts located in Sioux Falls, South Dakota.
        </p>
        <p>
          <em>Miscellaneous</em>
          . You will be responsible for paying, withholding, filing, and reporting all taxes,
          duties, and other governmental assessments associated with your activity in connection with the
          Services, provided that the CML may, in its sole discretion, do any of the foregoing on your behalf or
          for itself as it sees fit. The failure of either you or us to exercise, in any way, any right herein
          shall not be deemed a waiver of any further rights hereunder. If any provision of these Terms is found
          to be unenforceable or invalid, that provision will be limited or eliminated, to the minimum extent
          necessary, so that these Terms shall otherwise remain in full force and effect and enforceable. You and
          CML agree that these Terms are the complete and exclusive statement of the mutual understanding between
          you and CML, and that these Terms supersede and cancel all previous written and oral agreements,
          communications and other understandings relating to the subject matter of these Terms. You hereby
          acknowledge and agree that you are not an employee, agent, partner, or joint venture of CML, and you do
          not have any authority of any kind to bind CML in any respect whatsoever.
        </p>
        <p>
          Except as expressly set forth in the sections above regarding the Apple Application and the arbitration
          agreement, you and Company agree there are no third party beneficiaries intended under these Terms.
        </p>
      </div>
    </Container>
  );
};
